import styled from 'styled-components';
import { ReactComponent as _ContextMenuIcon } from 'styles/icons/context-menu-icon.svg';
import _LinkContextMenu from 'routes/surface/components/link-context-menu';
import { withModifiers } from 'utils/styles';
import surfaceIcon from 'styles/icons/surface.svg';
import documentIcon from 'styles/icons/document.svg';
import textIcon from 'styles/icons/text.svg';
import noteIcon from 'styles/icons/note.svg';
import { Row as _Row } from 'components/layout';
import { size } from 'styles/settings/typography';
import { color } from 'styles/settings';

const blueColor = color.brand.blue;

export const Row = styled(_Row)`
  margin-top: 10px;
  margin-bottom: 32px;
`;

export const Container = styled.div`
  width: calc(100% - 30px);
  padding-bottom: 5px;
`;

export const BottomBorder = styled.div`
  height: 40px;
  border-bottom: 1px solid ${color.neutral.grayLight};
`;

export const LinkSurface = styled.div`
  opacity: 1;
  cursor: pointer;
  transition: opacity 1s;
  color: ${color.neutral.plainBlack};
  ${withModifiers('hidden')`
        opacity: 0;
    `}
  line-height: 58px;
  :before {
    content: '';
    display: inline-block;
    position: relative;
    top: 3px;
    margin-right: 8px;
    width: 24px;
    height: 18px;
    background-size: 24px 18px;
    background-image: url('${({ parentType }) => {
      if (parentType?.includes('Document')) {
        return documentIcon;
      }

      if (parentType?.includes('Note')) {
        return noteIcon;
      }

      if (parentType?.includes('Text')) {
        return textIcon;
      }
      return surfaceIcon;
    }}');
  }
`;

export const LinkNameContainer = styled.div`
  margin-bottom: 5px;
`;

export const LinkName = styled.span`
  font-size: ${size.sm};
  color: ${({ color = blueColor }) => color};
`;

export const LinkedNodes = styled(_Row)`
  font-size: ${size.sm};
`;

export const ContextMenuIcon = styled(_ContextMenuIcon)`
  width: 38px;
  height: 38px;
  color: ${color.brand.greenDark};
  cursor: pointer;
`;

export const LinkContextMenu = styled(_LinkContextMenu)`
  opacity: 0;
  display: none;
  ${withModifiers('visible')`
    opacity: 1;
    transition: opacity 1s;
    display: flex;
  `}
`;

export const NodeContainer = styled.div`
  cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
`;
